/**
 * Guest tapped “Custom” on handwritten send stationery grid: session marker so post-login we can branch
 * (active `/me` → My handwriting vs storefront). Also used by AuthDrawer to extend screen lock across redirect.
 */
export const HANDWRITTEN_CUSTOMIZE_LOGIN_INTENT_KEY = 'handwritten_note_customize_login_intent'
